<template>
  <v-app>
    <core-app-bar />

    <core-drawer />

    <core-logout-view />

    <core-footer />

  </v-app>
</template>

<script>
export default {
  name: 'Logout',

  components: {
    CoreAppBar: () => import('../components/core/AppBar'),
    CoreDrawer: () => import('../components/core/Drawer'),
    CoreLogoutView: () => import('../components/core/LogoutView'),
    CoreFooter: () => import('../components/core/Footer'),
  },

  data: () => ({
    expandOnHover: false,
  }),
}
</script>
